import _ from 'lodash';
import settings from '../../config/settings';
import DestinationTypes from '../const/DestinationTypes';
import {createImgObject, getImageUrl} from './ApiUtils';

/*
 * Return full program entity with fields set in card overwriting the defaults from program (e.g. title, poster_image, etc.)
 */
export function mergeCardWithProgram(card, program) {
  const mergeSource = _.cloneDeep(card);

  const cardChanges = _.pickBy(_.omit(mergeSource,
    'posterVideo',
    'posterImage',
    'destinations',
    'recordUrls',
    'network'), p => !!p);

  let merged = _.cloneDeep(program);
  if (_.get(mergeSource, 'posterVideo.url')) {
    cardChanges.posterVideo = _.cloneDeep(mergeSource.posterVideo);
    merged = _.omit(merged, 'posterVideo');
  }
  if (getImageUrl(mergeSource.posterImage)) {
    cardChanges.posterImage = _.cloneDeep(mergeSource.posterImage);
    merged = _.omit(merged, 'posterImage');
  }
  if (!getImageUrl(mergeSource.posterImageHorizontal) && getImageUrl(program.posterImageHorizontal)) {
    cardChanges.posterImageHorizontal = _.cloneDeep(program.posterImageHorizontal);
    merged = _.omit(merged, 'posterImageHorizontal');
  }

  merged.destinations = mergeSource.destinations;

  if (!_.find(merged.destinations, {kind: DestinationTypes.network})) {
    if (program.networkLink && program.network) {
      const logoUrl = settings.widget.networkLogoColor ? (program.network.logoUrl || program.network.whiteLogoUrl) : (program.network.whiteLogoUrl || program.network.logoUrl);
      merged.destinations.push({
        image: createImgObject(logoUrl),
        url: program.networkLink,
        kind: DestinationTypes.network,
        name: program.network.name,
        slug: '',
        isActive: true,
        isAutoRedirect: false
      });
    }
  }

  return {...merged, ...cardChanges};
}

export function getTwitterImgUrl(card) {
  return getImageUrl(card.shareImageTwitter) || getShareImgUrl(card);
}

export function getShareImgUrl(card) {
  return getImageUrl(getShareImg(card));
}

export function getShareImg(card) {
  if (card.posterVideo) {
    return card.posterImageSquare || getHorizontalPosterImage(card);
  }
  return getHorizontalPosterImage(card);
}

export function getHorizontalPosterImageUrl(card, getDefaultIfEmpty = true) {
  return getImageUrl(getHorizontalPosterImage(card, getDefaultIfEmpty));
}

export function getHorizontalPosterImage(card, getDefaultIfEmpty = true) {
  return card.posterImageHorizontal || getPosterImage(card, getDefaultIfEmpty);
}

export function getProgramHorizontalPosterImageUrl(program) {
  return getImageUrl(program.posterImageHorizontal) || getImageUrl(program.posterImage) || null;
}

export function getPosterImageUrl(card, getDefaultIfEmpty = true) {
  return getImageUrl(getPosterImage(card, getDefaultIfEmpty));
}

export function getPosterImage(card, getDefaultIfEmpty = true) {
  return card.posterImage || (getDefaultIfEmpty ? {fullSize: {url: getDefaultPosterUrl()}} : null);
}

export function getDefaultPosterUrl() {
  return _.get(settings, 'create.defaultCoverUrl');
}

export function getDefaultTriggerButtonUrl() {
  return _.get(settings, 'widget.triggerButtonImage');
}

export function getPosterVideoUrl(card) {
  return _.get(card, 'posterVideo.url', '');
}

export function getSnippetCode(id) {
  return `<span class=vuCardTrigger data-card-id=${id}><script type=text/javascript async defer src=${settings.frontendBaseURL + 'static/widget.js'}></script></span>`;
}

export function getCardUrl(id) {
  return `${settings.frontendBaseURL}c/${id}`;
}

export function isApproved(card) {
  return card.customizationStatus === 'approved';
}

export function isRejected(card) {
  return card.customizationStatus === 'rejected';
}

export function isPending(card) {
  return card.customizationStatus === 'pending';
}

export function getTrackingCode(codeConfig, deviceType, eventType) {
  const {devices, event} = codeConfig;
  if ((!eventType || event === eventType) && (_.isEmpty(devices) || devices.includes(deviceType))) {
    return codeConfig.code;
  }
  return null;
}

export function getEmptyCard() {
  return {
    user: 1,
    program: 1,
    destinations: [],
    title: '',
    shortSummary: '',
    posterImage: null,
    posterImageHorizontal: null,
    posterVideo: null,
    customizationStatus: '',
    rejectionReason: '',
    callToAction: '',
    renderPhrase: '',
    renderSearchPhrases: [],
    renderSearchPhraseRegex: '',
    trackingCodes: []
  };
}
